module.exports = __webpack_public_path__ + "static/flightonary-37e2c78c28e37428e3922dea08128525.jpg";